
import * as React from "react";

interface EventPropagationStopperProps {
  children: React.ReactNode;
  className?: string;
}

export function EventPropagationStopper({ 
  children, 
  className 
}: EventPropagationStopperProps) {
  // Stop propagation of all events to prevent calendar from closing
  const stopPropagation = (e: React.SyntheticEvent) => {
    e.stopPropagation();
  };

  return (
    <div 
      className={className}
      onClick={stopPropagation}
      onMouseDown={stopPropagation}
      onPointerDown={stopPropagation}
      style={{ pointerEvents: 'auto' }}
    >
      {children}
    </div>
  );
}
